/**
 * @description class name for auto testing
 */
export const AUTO_TEST_CLASS = {
  OLD_PRICE: 'old-price',
  NEW_PRICE: 'new-price',
};
